module.exports = __webpack_public_path__ + "static/media/everyone.f8ff4264.png";